import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';
import { makeGetTotalHeightForContexts, makeGetTotalWidthForContexts, updateDynamicHeight, updateDynamicWidth } from '../services/redux/dimensionsSlice';
import { useAppDispatch } from '../services/redux/hooks';
import { fnDebounceFunc } from '../services/shared';

interface IAppDimensions {
  registerElementRef: (context: string, key: string, ref: React.RefObject<HTMLElement>) => void;
  unregisterElementRef: (context: string, key: string) => void;
  debouncedTriggerDynamicDimensions: () => void;
}

export const AppDimensionsContext = createContext<IAppDimensions>({
  registerElementRef: () => {},
  unregisterElementRef: () => {},
  debouncedTriggerDynamicDimensions: () => {}
});

type AppDimensionsProviderProps = {
  children: React.ReactNode;
};

export const AppDimensionsProvider: React.FC<AppDimensionsProviderProps> = ({ children }) => {  
  const dispatch = useAppDispatch()

  const [elementRefs, setElementRefs] = useState<
    Array<{ context: string; key: string; ref: React.RefObject<HTMLElement> }>
  >([]);

  const registerElementRef = (context: string, key: string, ref: React.RefObject<HTMLElement>) => {
    // console.log('register element ref',context,key)
    setElementRefs(prev => [...prev, { context, key, ref }]);
  };

  const unregisterElementRef = (context: string, key: string) => {
    // console.log('unregister element ref',context,key)
    setElementRefs(prev => prev.filter(item => item.context !== context || item.key !== key));
  };
  const tFixedControls:[string,string,string,number,number][] = [
    // 'headers' context — includes padding offsets for content scroll area sizing
    ['div_DeveloperHeader', 'headers', 'header', 4.5, 0],
    ['div_ResponsiveAppBar', 'headers', 'devheader', 0, 0],
    ['div_Footer', 'headers', 'footer', 0, 0],
    // 'chrome' context — raw element heights for sidebar positioning (no offsets)
    ['div_DeveloperHeader', 'chrome', 'header', 0, 0],
    ['div_ResponsiveAppBar', 'chrome', 'appbar', 0, 0],
    ['div_Footer', 'chrome', 'footer', 0, 0],
  ];
  
  const debouncedTriggerDynamicDimensions = useCallback(fnDebounceFunc(() => {
    triggerDynamicDimensions()
    // onChange(aspect, newValue);
  }, 500), []);

  const triggerDynamicDimensions = () => {
    tFixedControls.forEach((tItem) => {
      const item = document.getElementById(tItem[0]);
      let height = 0
      let width = 0
      if (item) {
        height = item.offsetHeight + tItem[3]
        width = item.offsetWidth + tItem[4]
        // console.log(`${tItem[0]} height : ${height}`)
      } else {
        console.log(`${tItem[0]} not found`)
      }
      dispatch(updateDynamicHeight({ 
        context: tItem[1], 
        name: tItem[2], 
        value: height
      }));
      dispatch(updateDynamicWidth({ 
        context: tItem[1], 
        name: tItem[2], 
        value: width
        }));
      
    });
    // console.log(elementRefs)
    for (const { context, key, ref } of elementRefs) {
      console.log(context, key, ref)
      let height = 0
      let width = 0
      if (ref.current) {
        height = ref.current.clientHeight
        width = ref.current.clientWidth
      }

      dispatch(updateDynamicHeight({ 
        context: context, 
        name: key, 
        value:height
      }));
      dispatch(updateDynamicWidth({ 
        context:context, 
        name: key, 
        value:width
      }));        
    }
  };

  useEffect(() => {
    window.addEventListener("resize", triggerDynamicDimensions);
    triggerDynamicDimensions();
    return () => window.removeEventListener("resize", triggerDynamicDimensions);
  }, []);
  useEffect(() => {
    debouncedTriggerDynamicDimensions();
  }, [elementRefs]);
  return (
    <AppDimensionsContext.Provider value={{
              registerElementRef,unregisterElementRef
              , debouncedTriggerDynamicDimensions  }}>
      {children}
    </AppDimensionsContext.Provider>
  );
};
